import { useTranslation } from 'next-i18next';
import { Box } from '@bridebook/ui';
import SectionHeading from '@bridebook/web/app-shared/components/supplier/sections/section-heading';
import SectionText from '@bridebook/web/app-shared/components/supplier/sections/section-text/section-text';
import componentStyles from '@bridebook/web/app-basic/components/supplier/sections/personal-message/personal-message.style';

interface IProps {
  managerName?: string;
  managerMessage?: string;
}

const PersonalMessage = ({ managerName, managerMessage }: IProps) => {
  const { t } = useTranslation('supplier');

  const styles = componentStyles();

  return (
    <Box>
      <SectionHeading largeMargin>{t('supplier.personal.message.title')}</SectionHeading>
      <Box>
        {managerName && (
          <Box style={styles.contactWrap}>
            <SectionText lineHeight={30}>
              {t('supplier.personal.message.sectionTxt', { managerName })}
            </SectionText>
          </Box>
        )}
        {managerMessage && <SectionText lineHeight={30}>{managerMessage}</SectionText>}
      </Box>
    </Box>
  );
};

export default PersonalMessage;
